'use strict';

import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { SponsorStudiesStorage } from './sponsor-studies-storage';
import { UrlBuilder } from '../core/url-builder/url-builder';
import { StudyCard } from './study-card';
import { PendoService } from '../shared/pendo-service/pendo-service';

declare const pendo: any;

@Component({
    selector: 'study-card',
    template: require('./study-card.component.html'),
    styles: [require('./study-card.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StudyCardComponent {

    @Input()
    public studyCard: StudyCard;

    constructor(private sponsorStudiesStorage: SponsorStudiesStorage,
                private changeDetector: ChangeDetectorRef,
                private urlBuilder: UrlBuilder,
                private pendoService: PendoService) { }

    public toggleFavorite() {
        this.studyCard.study.isFavorite = !this.studyCard.study.isFavorite;
        this.sponsorStudiesStorage.saveStudyIsFavorite(this.studyCard.study);
        this.changeDetector.markForCheck();
    }

    public goToStudy() {
        this.pendoService.updateSponsorPendoDetails(this.studyCard.study);
        return this.urlBuilder
            .esa()
            .sponsor()
            .study(this.studyCard.study)
            .sites()
            .navigate();
    }
}
